exports.default = "WebpackMultiOutput-/home/runner/work/web/web/static/nls/collections-carousel.js-WebpackMultiOutput";